import React from "react";
import { Pause, Play } from "lucide-react";

export const fmtDT = (iso) =>
  iso
    ? new Date(iso).toLocaleString("es-ES", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" })
    : "—";

const barColor = (pct) => (pct >= 95 ? "#D6002F" : pct >= 85 ? "#F59E0B" : pct >= 70 ? "#A78BFA" : "#7C3AED");

const STATE_STYLE = {
  activa: "bg-violet-500/15 border-violet-400/40 text-violet-100",
  pausada: "bg-white/10 border-white/20 text-white/70",
  bloqueada: "bg-red-500/15 border-red-500/40 text-red-100",
  enfriando: "bg-amber-500/15 border-amber-500/40 text-amber-100",
};

export const QuotaCard = ({ q, onTogglePause }) => (
  <div className="creep-glass p-5" data-testid={`quota-card-${q.id}`}>
    <div className="flex items-start justify-between gap-3">
      <div>
        <div className="text-[10px] uppercase tracking-[0.28em] text-[#8A6BFF]">{q.label}</div>
        <div className="mt-2 flex items-baseline gap-1.5">
          <span className="text-3xl font-extrabold" data-testid={`quota-count-${q.id}`}>{q.count}</span>
          <span className="text-white/50 text-sm">/ {q.limit}</span>
        </div>
      </div>
      <span className={`text-[10px] uppercase tracking-widest px-2 py-1 rounded-full border ${STATE_STYLE[q.state]}`} data-testid={`quota-state-${q.id}`}>
        {q.state}
      </span>
    </div>
    <div className="mt-4 h-2 rounded-full bg-white/5 overflow-hidden relative">
      {[70, 85, 95].map((t) => (
        <span key={t} className="absolute top-0 bottom-0 w-px bg-white/25" style={{ left: `${t}%` }} />
      ))}
      <div className="h-full rounded-full transition-[width] duration-700" style={{ width: `${Math.min(100, q.pct)}%`, background: barColor(q.pct) }} />
    </div>
    <div className="mt-3 grid grid-cols-2 gap-y-1 text-[11px] text-white/55">
      <span>Uso: <b className="text-white">{q.pct}%</b></span>
      <span>Restantes: <b className="text-white">{q.remaining}</b></span>
      <span>Permitidas hasta ahora: <b className="text-white">{q.allowed_now}</b></span>
      <span>Errores: <b className="text-white">{q.errors || 0}</b></span>
      <span className="col-span-2">Consumo real Meteocat: <b className="text-white">{q.remote_count ?? "—"}</b></span>
      <span className="col-span-2">Última llamada OK: <b className="text-white">{fmtDT(q.last_success_at)}</b></span>
      {q.last_error && <span className="col-span-2 text-red-300/80 truncate" title={q.last_error}>Último error: {q.last_error}</span>}
    </div>
    <button
      onClick={() => onTogglePause(q)}
      className="mt-4 creep-btn-ghost inline-flex items-center gap-1.5 text-xs !py-1.5 !px-3"
      data-testid={`quota-pause-btn-${q.id}`}
    >
      {q.paused ? <Play size={12} /> : <Pause size={12} />}
      {q.paused ? "Reanudar" : "Pausar"}
    </button>
  </div>
);

export const PanelList = ({ title, items, empty, render, testId }) => (
  <div className="creep-glass p-5" data-testid={testId}>
    <div className="text-[10px] uppercase tracking-[0.28em] text-[#8A6BFF] mb-3">{title}</div>
    {items.length === 0 ? (
      <div className="text-xs text-white/45">{empty}</div>
    ) : (
      <ul className="space-y-2 max-h-80 overflow-auto pr-1">{items.map(render)}</ul>
    )}
  </div>
);
